module.exports = __webpack_public_path__ + "static/media/client-logo-30.91a01078.jpg";